<template>
  <div class="Reference">
    <div
      v-if="moduleIsShow == 'true'"
      class="hl-info"
      @click="open('newReference')"
    >
      <span>{{ title }}</span>
      <i class="iconfont icon-right_medium"></i>
    </div>
    <div v-else class="hl-info" @click="openClass()">
      <span>{{ title }}</span>

      <i
        class="iconfont"
        :class="isBoolean ? 'icon-up_medium' : 'icon-down_medium'"
      ></i>
    </div>
    <div v-if="isBoolean" class="show-box"></div>
    <div v-if="isBoolean">
      <Empty v-if="dataList == ''" />
      <div v-else>
        <ReferContent v-show="isBoolean" :dataList="dataList" />
      </div>
    </div>
  </div>
</template>
<script>
import ReferContent from "@/components/openClose/ReferContent.vue";
import { Reference } from "@/api/reportQuery";
import { mapState } from "vuex";
import isiOS from "@/utils/iosAn";

export default {
  props: {
    moduleAnnotation: {
      type: String,
    },
    title: {
      type: String,
      default: "参考文献",
    },
    moduleIsShow: {
      type: String,
      default: "false",
    },
    templateIsShow: {
      type: String,
    },
    templateId: {
      type: String,
    },
  },
  components: {
    ReferContent,
  },
  data() {
    return {
      isOpen: false,
      dataList: [],
      isBoolean: this.templateIsShow == "false" ? true : false,
    };
  },
  computed: {
    ...mapState("embry", ["publicParams"]),
  },
  watch: {
    templateIsShow: function (bool) {
      console.log(bool, "hhhahahahahh");
    },
  },
  mounted() {
    console.log(Boolean(this.templateIsShow), "hhhahahahahh");

    this.getData();
  },
  methods: {
    openClass() {
      this.isBoolean = !this.isBoolean;
    },
    open(name) {
      if (this.$route.query.userAgent == "wxWeb") {
          wx.miniProgram.navigateTo({
            url: "/packageWebView/pages/new-reference/new-reference?moduleId=" + this.templateId,
          });
        } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({ name: name });
      } else {
        window.android.JSCallNative(JSON.stringify({ name: name }));
      }
      // this.$router.push({
      //   name: 'newReference',
      //   query:{
      //     sessionId:this.$route.query.sessionId
      //   }
      // })
    },
    async getData() {
      try {
        let { data } = await Reference({
          labOriginalSampleNo: this.publicParams.labOriginalSampleNo,
          productId: this.publicParams.productId,
          moduleId: this.templateId,
        });
        this.dataList = data;
      } catch (error) {}
    },
  },
};
</script>
<style lang="less" scoped>
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
  margin-bottom: 10px;
}
.Reference {
  margin-bottom: 20px;
  background: @background_color;
  border-radius: 10px;
  .hl-info {
    height: 70px;
    font-size: 18PX;
    padding: 0 24px;
    font-weight: 500;
    color: #2f354d;
    line-height: 70px;
    background: @background_color;
    border-radius: 10px;
    i {
      float: right;
    }
  }
}
</style>
